import ModelFactory from '../model-factory';
import { BaseModel } from '../models';

const isUUID = (str) => /^U'([A-Z]|\d){32}'$/.test(str);

const buildNestedIfNeeded = (opts) => {
  if (typeof opts === 'object' && opts != null) {
    // eslint-disable-next-line no-use-before-define
    return new SearchResultItem(opts);
  }

  if (typeof opts === 'string' && isUUID(opts)) {
    return opts.replace(/^U'(.*)'$/, '$1');
  }

  return opts;
};

export default class SearchResultItem extends BaseModel {
  constructor(opts = {}) {
    super(opts);

    Object.keys(opts)
      .filter((opt) => opt !== '@id' && opt !== '@COMMON_NAME')
      .forEach((key) => {
        if (opts[key] instanceof Array) {
          this[key] = opts[key].map((childrenOpts) => buildNestedIfNeeded(childrenOpts));
        } else {
          this[key] = buildNestedIfNeeded(opts[key]);
        }
      });
  }
}

export const formatSearchResult = (ns, data) => {
  const modelFactory = new ModelFactory(ns, (res) => new SearchResultItem(res));
  return modelFactory.format(data);
};
